import { DataManager } from 'utils/DataManager/dataManager';
import { ITeamCycleManager } from 'typings/dataManagers';
import { DataState } from 'typings/enums';

class TeamCycleManager extends DataManager implements ITeamCycleManager {
    async closePlan<T>(
        masterAccountId: string,
        cycleId: Nullable<number>,
        event: T,
        blockUi: boolean = false): Promise<void> {
        const receive = () => this._postDataRequest<T, void>(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/events`, event);
        await this.getData<void>(receive, blockUi);
    }

    getTeamOverviewSummary(masterAccountId: string, cycleId: number): Promise<Nullable<ITeamOverviewSummary>> {
        const receive = () => this._getDataRequest<ITeamOverviewSummary>(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/summary`);
        const dataOptions = {
            getDataFunc: receive,
            blockUi: false,
            redirectOnError: true
        };
        return this.getDataWithOptions<ITeamOverviewSummary>(dataOptions);
    }

    getTeamWorkflowSummaries(masterAccountId: string, cycleId: number): Promise<Nullable<IStatusSummary>> {
        const receive = () => this._getDataRequest<IStatusSummary>(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/summary/workflow`);
        const dataOptions = {
            getDataFunc: receive,
            blockUi: false,
            redirectOnError: true
        };
        return this.getDataWithOptions<IStatusSummary>(dataOptions);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }
}

export { TeamCycleManager };
export default TeamCycleManager;